export default {
    topics: [
        {
            title: ' Application (Class) ',
            href: 'c-Application.html',
            attributes: { 'data-id': 'c-Application' },
            menu: { hasChildren: false },
            tocID: 'c-Application-d66e5805',
            next: 'c-Application-d66e5805',
        },
        {
            title: ' CurrentOperator (Class) ',
            href: 'c-CurrentOperator.html',
            attributes: { 'data-id': 'c-CurrentOperator' },
            menu: { hasChildren: false },
            tocID: 'c-CurrentOperator-d66e5926',
            next: 'c-CurrentOperator-d66e5926',
        },
    ],
};

